export const sliceContent = (content: string, maxChars?: number) =>
  maxChars && content.length > maxChars ? `${content.slice(0, maxChars)}...` : content;
